export const breakpoints = Object.freeze({
	mobile: 320,
	tablet: 1024,
	desktopS: 1280,
	desktopM: 1440,
	desktopXL: 1512,
	desktopXXL: 1600,
});
